import React, { Fragment } from 'react';
import { connect } from "react-redux";
import { compose } from "redux";
import { getInAppNotificationsByContact, markAllNotificationsAsRead } from "store/state/notifications";
import { NavLink } from "react-router-dom";
import styled from 'styled-components';
import { ClickAwayListener, Divider, Drawer, Grid, withStyles } from "@material-ui/core";
import { ButtonIcon } from "@loanbossinc/component-library";
import CloseButton from "components/Global/Buttons/CloseButton";
import NotificationItem from "./NotificationItem";

const styles = {
  drawerPaper: {
    background: "#fff",
    marginTop: '50px',
    width: '600px',
  },
};

const Spacer = styled.div`
  width: 55px;
`;

const StyledDivider = styled(Divider)`&& {
    margin-top: 10px;
    margin-bottom: 10px;
  }
`;

const PaddedWrapper = styled.div`
  padding: 16px;
  margin-left: 16px;
  max-width: 800px;
`;
const NotificationsHeader = styled.div`
  display: flex;
  flex-flow: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
`;

const Title = styled.div`
  font-weight: bold;
  font-size: 20px;
  color: #333;
`;

const StyledHeaderLink = styled(NavLink)`
  font-size: 17px;
  color: #0f9ad6;
`;

const NotificationsListContainer = styled.div`
    color: #333;
`;

const NotificationButtonContainer = styled.div`{
  .button-icon {
    width: 38px;
    height: 38px;
  }
  
  .button-icon:hover {
    background-color: #3f51b5;
  }
}`;
class NotificationsMenu extends React.Component {
  state = {
    isDrawerOpen: false
  };

  componentDidMount() {
    this.props.getInAppNotificationsByContact();
  }

  closeDrawer = () => {
    this.setState({ isDrawerOpen: false });
  };

  openDrawer = () => {
    const key = "in_app_notification_ids";
    const currentStateOfDrawer = this.state.isDrawerOpen;
    this.setState({ isDrawerOpen: !currentStateOfDrawer });

    const notificationIds = localStorage.getItem(key);
    if (notificationIds) {
      const notificationIdsArray = JSON.parse(notificationIds);
      this.props.markAllNotificationsAsRead(notificationIdsArray);
    }
  };

  isLast = (index, notificationCount) => {
    return index === notificationCount - 1;
  };

  createNotification = (notification, index, notificationCount) => {
    if (this.isLast(index, notificationCount))
      return (<NotificationItem key={notification.id} notification={notification} />);
    else
      return (
        <Fragment key={notification.id}>
          <NotificationItem notification={notification} />
          <StyledDivider />
        </Fragment>
      );
  };

  render() {
    const { isDrawerOpen } = this.state;
    const { classes, inAppNotifications } = this.props;

    if (!inAppNotifications || !inAppNotifications.details || !inAppNotifications.details.listOfNotifications) return null;

    const notifications = inAppNotifications.details.listOfNotifications;
    const showNewNotificationsIcon = inAppNotifications.details.showNewNotificationsIcon;

    return (
      <>
        <Drawer open={isDrawerOpen} anchor="right" classes={{ paper: classes.drawerPaper }}>
          <ClickAwayListener onClickAway={this.closeDrawer}>
            <PaddedWrapper>
              <NotificationsHeader>
                <Title>Notification History</Title>
                <StyledHeaderLink to="/notifications" activeclassname="selected" onClick={() => this.closeDrawer()} >
                  MANAGE NOTIFICATIONS
                </StyledHeaderLink>
                <Spacer />
                <CloseButton onClick={() => this.closeDrawer()} />
              </NotificationsHeader>
              <NotificationsListContainer>
                <Grid container direction="column">
                  {notifications.map((x, i) => this.createNotification(x, i, notifications.length))}
                </Grid>
              </NotificationsListContainer>
            </PaddedWrapper>
          </ClickAwayListener>
        </Drawer>
        <NotificationButtonContainer>
          {showNewNotificationsIcon && <ButtonIcon styles={{ height: '38px', width: '38px' }} isSelected iconName="notifications" onClick={this.openDrawer} />}
          {!showNewNotificationsIcon && <ButtonIcon styles={{ height: '38px', width: '38px' }} isSelected iconName="notifications_none" onClick={this.openDrawer} />}
        </NotificationButtonContainer>
      </>
    )
  }
}

const mapStateToProps = ({ notifications }) => ({
  inAppNotifications: notifications.inAppNotifications,
});

export default compose(
  connect(
    mapStateToProps,
    {
      getInAppNotificationsByContact,
      markAllNotificationsAsRead,
    }
  ),
  withStyles(styles)
)(NotificationsMenu);
